import React, { useEffect, useState } from "react";
import styles from "../onboard.module.css";
import { Row, Card, Col, Button, Spinner, Modal } from "react-bootstrap";
import { saveBankDetail } from "../../../api";
import { useMyContext } from "../../../myContext";
import addicon from "../../signup/assets/addFundsGrey.svg";
import { fetchRemitterBankDetail } from "../../../api";
import CardDetail from "../../../common/CardDetails/CardDetail";
import greentickmark from "../../signup/assets/greenTickIcon.svg";
import BeneficiaryBankForm from "./beneficiaryBankForm";
import cross from "../../../public/assets/closeIcon.svg";
import CommonButton from "../../CommonButton/CommonButton";

const BeneficiaryBankDetail = ({
  isBeneficiaryFoamFlow,
  stepToShow,
  setStepsToShow,
  setShortBankDetail,
  shortBankDetail,
  showBeneficiaryBankDetail,
  setShowBeneficiaryBankDetail,
  beneficiaryBankCardSelection,
  setBeneficiaryBankCardSelection,
}) => {
  const [accountHolderName, setAccountHolderName] = useState("");
  const [bankName, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [confirmAccNumber, setConfirmAccNumber] = useState("");
  const [accountType, setAccountType] = useState("");
  const [branchName, setBranchName] = useState("");
  const [swiftCode, setSwiftCode] = useState("");
  const [ibanBsbRouting1, setIbanBsbRouting1] = useState("");
  const [ibanBsbRouting2, setIbanBsbRouting2] = useState("");
  const [bankAddress, setBankAddress] = useState("");
  const [currency, setCurrency] = useState("");
  const [codeType1, setCodeType1] = useState("");
  const [codeType2, setCodeType2] = useState("");
  const [tranferCode, setTransferCode] = useState(null);
  const [loading, setLoading] = useState("");
  const [accountTypeError, setAccountTypeError] = useState("");
  const [currencyError, setCurrencyError] = useState("");
  const [confirmAccNoErrror, setConfirmAccNoError] = useState("");
  const [nextSectionError, setNextSectionError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [valid, setIsValid] = useState({
    accountHolderName: false,
    bankName: false,
    accountNumber: false,
    confirmAccNumber: false,
    accountType: false,
    branchName: false,
    routingNo: false,
    swiftCode: false,
    bankAddress: false,
    ibanBsbRouting1: false,
    ibanBsbRouting2: false,
  });

  const {
    beneficiaryUserId,
    beneficiryBankId,
    setBeneficiaryBankId,
    beneficiaryBankSecondFlow,
    setBeneficiaryBankSecondFlow,
    selectedBeneficiaryBank,
    setSelectedBeneficiaryBank,
    setCompletedBeneficiary,
    countryObject,
    completedRemitter,
    completedBeneficiary,
    completedStudent,
    showBeneficiaryDetail,
    themeColor,
  } = useMyContext("");
  const [filteredList, setFilteredList] = useState([]);
  const [beneficiaryBankLoader, setBeneficiaryBankLoader] = useState(false);
  const [addnewButton, setAddnewButton] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const fetchBeneficiaryBankData = async () => {
    try {
      fetchRemitterBankDetail(beneficiaryUserId).then((response) => {
        setBeneficiaryBankLoader(false);
        if (response && response.data && response.data.length === 0) {
          setAddnewButton(true);
          setBeneficiaryBankCardSelection(false);
          setBeneficiaryBankSecondFlow(false);
          setStepsToShow("BeneficiaryStep2");
        } else {
          setAddnewButton(false);
          setBeneficiaryBankSecondFlow(true);
          setBeneficiaryBankCardSelection(true);
          if (beneficiryBankId) {
            const selectedCard = response.data.find(
              (item) => item.bankAccountId === beneficiryBankId
            );
            if (selectedCard) {
              const temporaryList = response.data.filter(
                (item) => item.bankAccountId !== beneficiryBankId
              );
              temporaryList.push(selectedCard);
              setFilteredList(temporaryList);
            }
          } else {
            setFilteredList(response.data);
          }
        }
      });
    } catch (error) {
      setBeneficiaryBankLoader(false);
    }
  };

  useEffect(() => {
    if (countryObject && countryObject.transferCode) {
      setTransferCode(countryObject.transferCode);
      if (
        Array.isArray(countryObject.transferCode) &&
        countryObject.transferCode.length > 0
      ) {
        setCodeType1(countryObject.transferCode[0]);
      } else {
        setCodeType1("");
      }
      if (countryObject.transferCode.length === 2) {
        setCodeType2(countryObject.transferCode[1]);
      } else {
        setCodeType2("");
      }
    } else {
      setTransferCode(null);
    }
    if (countryObject && countryObject.currencyList) {
      if (countryObject.currencyList.length === 1) {
        setCurrency(countryObject.currencyList[0]);
        sessionStorage.setItem("currencyCode", countryObject.currencyList[0]);
      } else {
        setCurrency("");
      }
    }
  }, [countryObject]);

  useEffect(() => {
    if (selectedBeneficiaryBank) {
      setBeneficiaryBankId(selectedBeneficiaryBank.bankAccountId);
    }
  }, [selectedBeneficiaryBank]);

  useEffect(() => {
    if (
      completedRemitter &&
      completedStudent &&
      !completedBeneficiary &&
      showBeneficiaryDetail &&
      !showBeneficiaryBankDetail
    ) {
      setBeneficiaryBankLoader(true);
      fetchBeneficiaryBankData();
    }
  }, [completedRemitter, completedStudent]);

  function maskAccountNumber(accountNumber) {
    if (accountNumber.length < 4) {
      return accountNumber;
    }

    const last4Digits = accountNumber.slice(-4);
    const maskedAccountNumber =
      "X".repeat(Math.max(0, accountNumber.length - 4)) + last4Digits;

    return maskedAccountNumber;
  }

  const handleChangeOption = (value) => {
    setAccountType(value);
  };

  useEffect(() => {
    if (beneficiaryBankCardSelection) {
      setShowBeneficiaryBankDetail(false);
      setBeneficiaryBankLoader(true);
      fetchBeneficiaryBankData();
    }
  }, [beneficiaryBankCardSelection]);

  const beneficiaryBankDetailApi = () => {
    setLoading(true);
    const body = {
      accountHolderName: accountHolderName,
      bankName: bankName,
      accountNo: accountNumber,
      bankAccountType: accountType,
      bankAddress: bankAddress,
      branch: branchName,
      swiftCode: swiftCode,
      [codeType1 !== "" ? codeType1 : null]: ibanBsbRouting1,
      [codeType2 !== "" ? codeType2 : null]: ibanBsbRouting2,
      remarks: "added",
      currencyCode: currency,
    };
    saveBankDetail(body, beneficiaryUserId).then((resp) => {
      try {
        setLoading(false);
        if (resp && resp.status === 200 && resp.data && resp.data.data) {
          setBeneficiaryBankId(resp.data.data.bankAccountId);
          setBeneficiaryBankCardSelection(false);
          // sessionStorage.setItem("beneficiaryBank", bankName);
          setShortBankDetail({
            accountHolderName: accountHolderName,
            accountMasked: maskAccountNumber(accountNumber),
            bankName: bankName,
            swiftCode: swiftCode,
          });
          setShowModal(false);
          setShowBeneficiaryBankDetail(true);
          setBeneficiaryBankSecondFlow(true);
          setStepsToShow("");
          setCompletedBeneficiary(true);
          setAccountHolderName("");
          setBankName("");
          setAccountNumber("");
          setConfirmAccNumber("");
          setAccountType("");
          setBranchName("");
          setSwiftCode("");
          setIbanBsbRouting1("");
          setIbanBsbRouting2("");
          setBankAddress("");
        } else {
          setNextSectionError(
            resp && resp.data
              ? resp.data.message
              : "something went wrong, please try again later."
          );
        }
      } catch (err) {
        setLoading(false);
        setNextSectionError("something went wrong, please try again later.");
      }
    });
  };

  const checkIfValid = () => {
    setNextSectionError("");
    setAccountTypeError("");
    setCurrencyError("");
    if (currency === "") {
      setCurrencyError("Please select Currency");
    } else if (accountHolderName === "") {
      setIsValid({ ...valid, accountHolderName: true });
    } else if (bankName === "") {
      setIsValid({ ...valid, bankName: true });
    } else if (accountNumber === "") {
      setIsValid({ ...valid, accountNumber: true });
    } else if (confirmAccNumber === "") {
      setIsValid({ ...valid, confirmAccNumber: true });
    } else if (accountType === "") {
      setAccountTypeError("Please select Account Type");
    } else if (bankAddress === "") {
      setIsValid({ ...valid, bankAddress: true });
    } else if (branchName === "") {
      setIsValid({ ...valid, branchName: true });
    } else if (swiftCode === "") {
      setIsValid({ ...valid, swiftCode: true });
    } else if (codeType1 !== "" && ibanBsbRouting1 === "") {
      setIsValid({ ...valid, ibanBsbRouting1: true });
    } else if (codeType2 !== "" && ibanBsbRouting2 === "") {
      setIsValid({ ...valid, ibanBsbRouting2: true });
    } else if (confirmAccNoErrror !== "" || currencyError !== "") {
      setNextSectionError("Please fill all the required field correctly.");
    } else {
      setIsValid({
        accountHolderName: false,
        bankName: false,
        accountNumber: false,
        confirmAccNumber: false,
        accountType: false,
        branchName: false,
        swiftCode: false,
        bankAddress: false,
        ibanBsbRouting1: false,
        ibanBsbRouting2: false,
      });
      setNextSectionError("");
      beneficiaryBankDetailApi();
    }
  };

  const handleChangeNew = (e) => {
    e.preventDefault();
    setBeneficiaryBankCardSelection(false);
    setStepsToShow("BeneficiaryStep2");
    setShowModal(true);
  };

  const handleChangeBack = (e) => {
    e.preventDefault();
    setBeneficiaryBankCardSelection(true);
    setSelectedBeneficiaryBank(null);
    setShowBeneficiaryBankDetail(false);
    setCompletedBeneficiary(false);
    setStepsToShow("");
    setShowModal(false);
  };

  const hanldeNextClick = () => {
    setShortBankDetail({
      accountHolderName: selectedBeneficiaryBank.accountHolderName,
      accountMasked: selectedBeneficiaryBank.accountMasked,
      bankName: selectedBeneficiaryBank.bankName,
    });
    setShowBeneficiaryBankDetail(true);
    setBeneficiaryBankCardSelection(false);
    setCompletedBeneficiary(true);
    setStepsToShow("");
    setBeneficiaryBankId(selectedBeneficiaryBank.bankAccountId);
    sessionStorage.setItem(
      "currencyCode",
      selectedBeneficiaryBank.currencyCode
    );
  };

  return (
    <Card className={styles.cardAccount}>
      <Card.Body className={styles.cardBodyAccount}>
        <div className={styles.headingandbutton}>
          <Row className={styles.Title}>Bank Detail</Row>
          {beneficiaryBankSecondFlow === true &&
            beneficiaryBankLoader === false &&
            !isBeneficiaryFoamFlow && (
              <>
                {beneficiaryBankCardSelection === true ? (
                  <div
                    className={styles.buttonaddnew}
                    onClick={handleChangeNew}
                  >
                    <img src={addicon} alt=""></img>
                    Add new
                  </div>
                ) : (
                  <>
                    <div
                      className={
                        showBeneficiaryBankDetail === false
                          ? styles.buttonback
                          : styles.buttonEdit
                      }
                      onClick={handleChangeBack}
                    >
                      {showBeneficiaryBankDetail === true
                        ? "Edit"
                        : stepToShow === "BeneficiaryStep2"
                        ? "Back"
                        : ""}
                    </div>
                  </>
                )}
              </>
            )}
        </div>
        {beneficiaryBankLoader ? (
          <Spinner
            animation="border"
            className={styles.spinnerColorOutside}
            style={{ borderColor: themeColor, borderRightColor: "#eaecf0" }}
          />
        ) : (
          <>
            {showBeneficiaryBankDetail === true ? (
              <>
                <Row>
                  <Col md={11} sm={11} xs={10} className={styles.details}>
                    {shortBankDetail.accountHolderName},{" "}
                    {shortBankDetail.accountMasked}, {shortBankDetail.bankName}
                  </Col>
                  <Col md={1} sm={1} xs={2} style={{ position: "relative" }}>
                    <img
                      className={styles.greentick}
                      src={greentickmark}
                      alt=""
                    />
                  </Col>
                </Row>
              </>
            ) : beneficiaryBankSecondFlow === true &&
              beneficiaryBankCardSelection === true ? (
              <>
                <CardDetail
                  cardlist={filteredList}
                  setSelectedValue={setSelectedBeneficiaryBank}
                  selectedValue={selectedBeneficiaryBank}
                  BankType={true}
                  selectedUserid={beneficiryBankId}
                  type={"Beneficiary"}
                />
                {beneficiaryBankCardSelection === true &&
                  beneficiaryBankSecondFlow === true && (
                    <Row className="pt-3 mt-3">
                      <CommonButton
                        title="Next"
                        onClick={hanldeNextClick}
                        loading={false}
                        disabled={selectedBeneficiaryBank === null}
                        width={"150px"}
                      />
                    </Row>
                  )}
              </>
            ) : (
              <>
                {stepToShow === "BeneficiaryStep2" ? (
                  <>
                    <div className={styles.showonWeb}>
                      <hr style={{ marginTop: "0px" }} />
                      <BeneficiaryBankForm
                        accountHolderName={accountHolderName}
                        setAccountHolderName={setAccountHolderName}
                        valid={valid}
                        bankName={bankName}
                        setBankName={setBankName}
                        accountNumber={accountNumber}
                        setAccountNumber={setAccountNumber}
                        handleChangeOption={handleChangeOption}
                        accountTypeError={accountTypeError}
                        bankAddress={bankAddress}
                        setBankAddress={setBankAddress}
                        branchName={branchName}
                        setBranchName={setBranchName}
                        swiftCode={swiftCode}
                        setSwiftCode={setSwiftCode}
                        tranferCode={tranferCode}
                        ibanBsbRouting1={ibanBsbRouting1}
                        setIbanBsbRouting1={setIbanBsbRouting1}
                        ibanBsbRouting2={ibanBsbRouting2}
                        setIbanBsbRouting2={setIbanBsbRouting2}
                        setCurrency={setCurrency}
                        currencyError={currencyError}
                        nextSectionError={nextSectionError}
                        checkIfValid={checkIfValid}
                        loading={loading}
                        themeColor={themeColor}
                        confirmAccNumber={confirmAccNumber}
                        setConfirmAccNumber={setConfirmAccNumber}
                        confirmAccNoErrror={confirmAccNoErrror}
                        setConfirmAccNoError={setConfirmAccNoError}
                      />
                    </div>
                    {screenWidth < 576 && (
                      <>
                        {addnewButton && (
                          <Row>
                            <Col
                              sm={6}
                              xs={6}
                              className={styles.nodatafoundStyling}
                            >
                              No Data Found
                            </Col>
                            <Col sm={6} xs={6}>
                              <Button
                                style={{
                                  margin: "10px 0px",
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "14px",
                                }}
                                onClick={() => setShowModal(true)}
                              >
                                Add New
                              </Button>
                            </Col>
                          </Row>
                        )}
                        <Modal
                          show={stepToShow === "BeneficiaryStep2" && showModal}
                        >
                          <div style={{ padding: "20px" }}>
                            <Row>
                              <Col
                                md={9}
                                sm={9}
                                xs={9}
                                className={styles.Title}
                              >
                                Bank Detail
                              </Col>
                              <Col
                                md={3}
                                sm={3}
                                xs={3}
                                onClick={
                                  addnewButton
                                    ? () => setShowModal(false)
                                    : handleChangeBack
                                }
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  padding: "10px",
                                }}
                              >
                                <img src={cross} alt="nav-close" />
                              </Col>
                            </Row>
                            <hr style={{ marginTop: "0px" }} />
                            <BeneficiaryBankForm
                              accountHolderName={accountHolderName}
                              setAccountHolderName={setAccountHolderName}
                              valid={valid}
                              bankName={bankName}
                              setBankName={setBankName}
                              accountNumber={accountNumber}
                              setAccountNumber={setAccountNumber}
                              handleChangeOption={handleChangeOption}
                              accountTypeError={accountTypeError}
                              bankAddress={bankAddress}
                              setBankAddress={setBankAddress}
                              branchName={branchName}
                              setBranchName={setBranchName}
                              swiftCode={swiftCode}
                              setSwiftCode={setSwiftCode}
                              tranferCode={tranferCode}
                              ibanBsbRouting1={ibanBsbRouting1}
                              setIbanBsbRouting1={setIbanBsbRouting1}
                              ibanBsbRouting2={ibanBsbRouting2}
                              setIbanBsbRouting2={setIbanBsbRouting2}
                              setCurrency={setCurrency}
                              currencyError={currencyError}
                              nextSectionError={nextSectionError}
                              checkIfValid={checkIfValid}
                              loading={loading}
                              themeColor={themeColor}
                              confirmAccNumber={confirmAccNumber}
                              setConfirmAccNumber={setConfirmAccNumber}
                              confirmAccNoErrror={confirmAccNoErrror}
                              setConfirmAccNoError={setConfirmAccNoError}
                            />
                          </div>
                        </Modal>
                      </>
                    )}
                  </>
                ) : (
                  ""
                )}
              </>
            )}
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default BeneficiaryBankDetail;
